import { AirmontLogoImg } from "shared-ts-ui-airmont";
import React from "react";
import { AppInfo } from "shared-ts-app-info";

export const appKey = "ff-ci";
export const appName = "Chimney Insights";
export const appRelease = "2026.1.0";

export const appInfo: AppInfo = {
  key: appKey,
  name: appName,
  icon: {
    large: <AirmontLogoImg />,
  },
  release: appRelease,
};
